import type { PlanId } from "../api/types";
import { PlanIcon } from "./PlanIcon";

const TONE: Record<PlanId, string> = {
  free: "border-border bg-panel2 text-muted",
  basic: "border-brand/40 bg-brand/10 text-brand",
  pro: "border-accent/40 bg-accent/10 text-accent",
  fleet: "border-good/40 bg-good/10 text-good",
};

const LABEL: Record<PlanId, string> = {
  free: "Free Cloud",
  basic: "Basic",
  pro: "Pro",
  fleet: "Fleet",
};

export function PlanBadge({ plan }: { plan: PlanId }) {
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border ${TONE[plan]}`}>
      {/* Two-tone mark: fixed colours, so it reads the same in every
          plan's badge tone. */}
      <PlanIcon plan={plan} size={12} />
      {LABEL[plan]}
    </span>
  );
}
